import {inject, Injectable}            from '@angular/core';
import {CrudRecordType}                from '@djsharkk/logr-types';
import {gsap}                          from 'gsap';
import {MenuCrudService}               from './menu-crud.service';
import {MenuDragService, MenuDragType} from './menu-drag.service';

@Injectable({
				providedIn: 'root'
			})
export class MenuBaseService {

	svcMenuCrud = inject(MenuCrudService)
	svcMenuDrag = inject(MenuDragService)


	menuCrudToggle(panelIndex: number, type: CrudRecordType, panelId: string = 'PanelWrapperCrud') {
		this.menuDragClose();

		this.svcMenuCrud.menuOpen.next(!(type === this.svcMenuCrud.menuType.getValue() && this.svcMenuCrud.menuOpen.getValue()));
		this.svcMenuCrud.menuType.next(this.svcMenuCrud.menuOpen.getValue() ? type : undefined);

		const el = document.getElementById(panelId);
		if (!el) return;

		if (this.svcMenuCrud.menuType.getValue()) {
			this.menuPanelScroll(el, panelIndex, 'y')
		}
	}


	menuDragToggle(panelIndex: number, type: MenuDragType, panelId: string = 'PanelWrapperDrag') {
		const el = document.getElementById(panelId);
		if (!el) return;
		this.svcMenuDrag.menuType.next(type);
		this.menuPanelScroll(el, panelIndex, 'x')
	}

	menuPanelScroll(panel: HTMLElement, panelIndex: number, direction: 'x' | 'y') {
		const targetElement = panel.childNodes[panelIndex] as HTMLDivElement;
		if (targetElement) {
			gsap.to(
				panel,
				{
					duration: 0.5,
					ease    : 'power2.out',
					scrollTo: {
						[direction]: targetElement
					}
				}
			);
		}
	}

	menuCrudClose() {
		this.svcMenuCrud.menuOpen.next(false);
		this.svcMenuCrud.menuType.next(undefined)
	}

	menuDragClose() {
		this.svcMenuDrag.menuOpen.next(false);
		this.svcMenuDrag.menuType.next(undefined);
	}
}
